export function getInitialState()
{
  return {
    debug:(process.env.NODE_ENV === "development") ? true :false, /* shows debug data when developing */
    loaded: false,
    loggedIn:false,
    user_schools:[], // schools are also stored in websql
    user_stored:{ // see STORE_USER_SETTING
      language:"nl",
      get_pushnotes:false,
      avatar:undefined, // only the local avatar, not uploaded yet..
      registrationId:undefined,
    },
    
    // all the different news lists to load
    news_featured:[],
    news:[], // multi dimensional array
    news_groups:[],

    news_item:{},
    albums:[], // multi dimensional array
    album:{},
    calendar:[], // multi dimensional array
    calendar_item:{},

    groups:[],
    group:{}, // the current group
    documents:[], // pdfs...,  multi dimensional array
    newsletters:[], // multi dimensional array
    emails:[], // multi dimensional array
    appSettings:{
      avatar:undefined,
      modules:{
        // modules that are (in)active
      }
    },
    teacher_talks:[],// multi dimensional array
    teacher_talks_slots:[],
    absences:[],// multi dimensional array
    openDrawerMenu:false,
    caroussel_fullscreen:false,
    pushnotes:[],
    chatpersons:[],
    chat_messages:[],//multi dimensional array with storekey
    absence_reasons:[],
  }
}